module.exports = __webpack_public_path__ + "img/greg-pro.3c79799f.jpg";